import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Input, Col } from 'reactstrap';
import moment from 'moment';

interface IReadingPlansCopyModalProps {
	isShowModal: boolean;
	readingPlanId: number;
	channelList: any;
	yearList: any;
	onSubmit: any;
	handleToggle:any;
	defaultChannelId?: number;
}

interface IReadingPlansCopyModalState {
	modal: boolean;
	backdrop: string;
	channelId: string;
	year: string;
	readingPlanId: number;
	preGenerateEpisodes: boolean;
	isYearErr: boolean;
}

class ReadingPlanCopy extends React.Component<IReadingPlansCopyModalProps, IReadingPlansCopyModalState>  {
	state: IReadingPlansCopyModalState;
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			backdrop: "static",
			channelId: this.getDefaultValue(this.props.defaultChannelId),
			year: "-1",
			readingPlanId: this.props.readingPlanId,
			preGenerateEpisodes: false,
			isYearErr: false,
		};
		this.handleToggle = this.handleToggle.bind(this);
	}

	getDefaultValue(value?: number) {
		return value && value > 0 ? value.toString() : "";
	}

	componentDidMount() {
		const { isShowModal } = this.props;
		this.setState({ modal: isShowModal });
	}

	handleToggle() {
		this.setState({ channelId: "", year: "-1", isYearErr: false });
		this.props.handleToggle();
	}

	componentWillReceiveProps(newProps) {
		const oldProps = this.props
		if (oldProps.isShowModal !== newProps.isShowModal) {
			this.setState({
				modal: newProps.isShowModal,
				channelId: this.getDefaultValue(newProps.defaultChannelId),
				year: "-1",
				isYearErr: false
			})
		}
		if (oldProps.readingPlanId !== newProps.readingPlanId) {
			let statusCopy = Object.assign({}, this.state);
			statusCopy.readingPlanId = newProps.readingPlanId;
			statusCopy.modal = newProps.isShowModal;
			statusCopy.channelId = this.getDefaultValue(newProps.defaultChannelId);
			statusCopy.year = "-1";
			statusCopy.isYearErr = false;
			this.setState(statusCopy);
		}
	}

	handleInputChange = (event) => {
		let name = event.target.name;
		let value = event.target.value;

		this.setState({ ...this.state, [name]: value });

		if (name === "year") {
			this.setState({ isYearErr: !this.isValidYear(value) });
		}
	};

	isValidYear(value: string) {
		const year = parseInt(value);
		return !isNaN(year) && year > 0;
	}

	handleSubmit = async (event) => {
		event.preventDefault();
		if (!this.isValidYear(this.state.year)) {
			return this.setState({ isYearErr: true });
		}

		var initialInputValue = {
			channelId: parseInt(this.state.channelId),
			year: parseInt(this.state.year),
			readingPlanId: this.state.readingPlanId,
			preGenerateEpisodes: this.state.preGenerateEpisodes,
		};
		await this.props.onSubmit(initialInputValue);

		this.setState({ channelId: "", year: "-1", preGenerateEpisodes: false, isYearErr: false });
	}

	render() {
		const { channelList, yearList } = this.props;
		return (
			<div>
				<Modal isOpen={this.state.modal} toggle={this.handleToggle} backdrop="static" className="reading-plan-copy">
					<ModalHeader className="modal-header" toggle={this.handleToggle}>ReadingPlan Copy</ModalHeader>
					<form name="createform" onSubmit={this.handleSubmit}>
						<ModalBody className="modal-body">
							<Col lg="10">
								<label>Channel</label>
								<div data-testid="channelContainer">
									<Input type="select" className="form-select" id="channelId" required name="channelId" value={this.state.channelId} onChange={(e) => { this.handleInputChange(e) }}>
										{channelList && channelList.sort((a: any, b: any) => a.text?.localeCompare(b.text)).map((data: any) =>
												<option key={data.value + "key"} value={data.value}>{data.text}</option>)}
									</Input>
								</div>
							</Col>

							<Col lg="10">
								<label>Year</label>
								<div data-testid="yearContainer">
									<Input type="select" className={["form-select", this.state.isYearErr ? "is-invalid" : ""].join(" ")} id="year" required name="year" value={this.state.year} onChange={(e) => { this.handleInputChange(e) }}>
										{yearList && yearList.map((data: any) =><option key={data.value + "key"} value={data.value}>{data.text}</option>)}
									</Input>
									<div style={{ display: `${this.state.isYearErr ? '' : 'none'}` }}>
										<label data-testid="yearErr" className="text-danger">Please select year.</label>
									</div>
								</div>
							</Col>

							<Col lg="10" className="mt-2">
								<div className="form-check">
									<Input
										type="checkbox"
										className="form-check-input"
										id="preGenerateEpisodes"
										checked={this.state.preGenerateEpisodes}
										onChange={(e) => this.setState({ preGenerateEpisodes: e.target.checked })}
									/>
									<label className="form-check-label" htmlFor="preGenerateEpisodes">Pre Generate Episodes</label>
								</div>
							</Col>
						</ModalBody>
						<ModalFooter>
							<div className='card-box'>
								<Row className="rpc-buttons">
									<Col lg="3">
										<button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.handleToggle}>CANCEL</button>
									</Col>
									<Col lg="3" data-testid="copyButtonContainer">
										<Button type="submit" id="Submit" className="btn-submit-frm" >COPY</Button>
									</Col>
								</Row>
							</div>
						</ModalFooter>
					</form>
				</Modal>
			</div>
		);
	}
}

export default ReadingPlanCopy;